import {ReactNode} from 'react';
import {IcnInfo} from "../../assets/icons";

interface FormGroupHelpTextProps {
  helpText?: ReactNode;
  hideHelpTextIcon?: boolean;
}

function FormGroupHelpText({helpText, hideHelpTextIcon}: FormGroupHelpTextProps) {
  return (
    <small className="c-form-group-help-text">
      {!hideHelpTextIcon && (
        <i><IcnInfo/></i>
      )}

      {helpText}
    </small>
  );
}

export default FormGroupHelpText;